/** Small id/time helpers shared by the IndexedDB layer. */

/** Generate a RFC-4122 v4 UUID (native `crypto.randomUUID`). */
export function newId(): string {
  return crypto.randomUUID();
}

/** Current time as an ISO-8601 string (UTC). */
export function nowIso(): string {
  return new Date().toISOString();
}
